<template>
  <div class="bg-white py-4 xl:hidden breakpoint-driven-widths">
    <Transition enter-from-class="h-0" enter-to-class="h-screen"
      enter-active-class="transition-[height] ease-linear duration-100">

      <!-- Tablet/Mobile Nav Menu -->
      <div v-if="isVisible" class="bg-white">
        <NuxtLink to="/cart"
          class="rounded-md text-white bg-[#191919] focus:bg-gray-700 hover:bg-gray-700 disabled:bg-gray-300 disabled:text-gray-600 transition-colors duration-200 ease-in-out flex items-center justify-center my-4 h-11"
          external>
          Checkout
        </NuxtLink>
        <div class="flex">
          <TgptButton @click="handleTooltip" class="mr-2 w-10" v-if="config?.public?.chatIframeEnabled === 'Y' && isMyComponentEnabled && isTaiaEnabled" />
          <SearchBar class="h-12 w-full" />
        </div>


        <ul class="flex flex-col gap-y-6 py-5 xl:items-center">
          <NavMenuLink v-for="(navLink, index) in navLinkList" :id="index" :label="navLink.label" :url="navLink.url"
            :tag="navLink.tag" :tag-text-color="navLink.tagTextColor" :tag-background-color="navLink.tagBackgroundColor"
            ref="mobileNavLinks" />
        </ul>

        <!-- Table/moble account Options -->
        <div class="flex flex-col gap-y-6 py-5 border-t border-gray-300" v-if="isLoggedIn">
          <span>{{ userName }}</span>
          <NuxtLink to="/account/settings/personal" external>
            Account Settings
          </NuxtLink>
          <NuxtLink to="/logout" external>
            Sign Out
          </NuxtLink>
        </div>
        <NuxtLink to="/login" v-else external>
          Sign In
        </NuxtLink>
      </div>
    </Transition>

    <!-- Tablet/Mobile Nav Search -->
    <div class="flex justify-center items-center gap-x-[8px]">
      <div class="taia-icon relative left-[-5px] top-[2px] xl:left-[6px] xl:top-[6px] w-[36px] h-[36px]" v-if="!isVisible && config?.public?.chatIframeEnabled === 'Y' && isMyComponentEnabled && isTaiaEnabled">
        <TgptButton @click="handleTooltip"  />
      </div>
      <div class="w-full">
        <SearchBar class="h-10" placeholder="Search products, articles, and more" v-if="!isVisible" />
      </div>
    </div>
    <!--tooltip message  -->
    <div v-if="showComponent && !showChatPopup && config?.public?.chatIframeEnabled === 'Y' && isMyComponentEnabled && isTaiaEnabled"
      class="absolute animate-fadeOut opacity-100 left-[10px]" v-click-outside="handleClickOutside">
      <TooltipMessage @close="handleClose" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useTemplateRef, onMounted } from 'vue'
import SearchBar from "~/components/ui/molecule/search/searchBar.vue";
import { NuxtLink } from "#components";
import NavMenuLink, { type BuilderNavLink } from "~/components/ui/atom/navMenuLink.vue";
import { useEventListener } from '@vueuse/core'
import TgptButton from './gpt/mainButton.vue';
import TooltipMessage from './gpt/tooltipMessage.vue';
import { useIframeStore } from '@/stores/chatAIStore';
import { useDynamicYieldStore } from '@/stores/dynamicYieldStore';
import eventBusGtm from '@/composables/eventBusGtm';




const nuxtApp = useNuxtApp()
const config = nuxtApp.$config

interface MobileNavMenuProps {
  navLinkList?: BuilderNavLink[]
  isLoggedIn?: boolean
  userName?: string
  isTaiaEnabled?:boolean
}
const showComponent = ref<boolean>(false);
const isVisible = defineModel('isVisible')
const {
  navLinkList = [],
  isLoggedIn = false,
  userName = '',
  isTaiaEnabled = false,
} = defineProps<MobileNavMenuProps>();

const mobileNavLinkRefs = useTemplateRef<EventTarget[] | null>('mobileNavLinks')
const iframeStore = useIframeStore();
const showChatPopup = computed(() => iframeStore.showChatPopup);

const dyStore = useDynamicYieldStore();

  const isMyComponentEnabled = computed(() => {
      const myVariationData = dyStore.getCustomJSONVariationBySelector(config?.public?.abTestName ?? '');
      return !!myVariationData?.data?.enabled;
  });
onMounted(() => {
  const onLinkClicked = () => isVisible.value = false

  mobileNavLinkRefs?.value?.map((element) => {
    useEventListener(element, 'click', onLinkClicked)
  })

  // Run when the component is mounted

  if (!sessionStorage.getItem('tooltipShown')) {
    setTimeout(() => {
      showComponent.value = true;

      // After 10 seconds, hide the component
      setTimeout(() => {
        showComponent.value = false;
      }, 10000); // 10,000ms = 10 seconds

      // Mark the tooltip as shown in the session
      sessionStorage.setItem('tooltipShown', 'true');
    }, 5000); // 5000ms = 5 seconds
  }
})
// Handler to trigger when 'close' event is emitted from child
const handleClose = () => {
  showComponent.value = false; // Update state or trigger any other action
};
const handleTooltip = () => {
  const screenName = document.title;
  eventBusGtm.emit('trackEvent', {
    event: 'Taia',
    button_name: 'click_into_chat_bot',
    screen_name: screenName,
  });
  showComponent.value = false;
}
const handleClickOutside = () => {
  if (showComponent) {
    showComponent.value = false;
  }
}

</script>

